import React, {useState} from "react";
import IconDropdown from "../../icons/IconDropdown";

const DropdownFilter = ({level, onSelect}) => {

  const {
    question,
    options,
  } = level;

  const [opened, setOpened] = useState(false);
  const [value, setValue] = useState('');

  return <div className="productFinder__question">
    <label>{question}</label>
    <div
      className="custom-dropdown"
      onClick={() => {
        setOpened(!opened)
      }}
    >
      <div className="dropdown-header">
        {value || 'Select from list'}
      </div>

      {!!opened && <div className="dropdown-options">
        {options.map((option, index) => {
          return <div
            key={index}
            className="dropdown-option"
            onClick={() => {
              setValue(option.option);
              if (onSelect) {
                onSelect(option)
              }
            }}
          >
            {option.option}
          </div>
        })}
      </div>}
      <IconDropdown />
    </div>
  </div>

}

export default DropdownFilter;
